import React from 'react'
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openTicketCreateModal } from '../../../../../../actions/ui';

export const DropDownMenuItems = ({ show, onItemClick }) => {
    const dispatch = useDispatch();

    const handleOpenTicketModal = () => {
        dispatch(openTicketCreateModal());
        if (typeof onItemClick === 'function') {
            onItemClick();
        }
    };

  return (
    <div className={`dropdown-menu nxl-h-dropdown ${show ? 'show' : ''}`}>
        <button type="button" className="dropdown nxl-level-menu border-0 bg-transparent p-0 w-100 text-start" onClick={handleOpenTicketModal} style={{cursor:'pointer'}}>
            <span className="dropdown-item" style={{cursor:'pointer'}}>
                <i className="feather-check-square"></i>
                <span>Ticket</span>
            </span>
        </button>
        <div className="dropdown-divider"></div>
        <div className="dropdown nxl-level-menu" style={{cursor:'pointer'}}>
            <Link className="dropdown-item" to="/customer/create" onClick={onItemClick}>
                <span className="hstack">
                    <i className="feather-users"></i>
                    <span>Cliente</span>
                </span>
            </Link>
        </div>
        <div className="dropdown nxl-level-menu" style={{cursor:'pointer'}}>
            <Link className="dropdown-item" to="/project/create" onClick={onItemClick}>
                <span className="hstack">
                    <i className="feather-briefcase"></i>
                    <span>Proyecto</span>
                </span>
            </Link>
        </div>
        <div className="dropdown nxl-level-menu" style={{cursor:'pointer'}}>
            <Link className="dropdown-item" to="/group/create" onClick={onItemClick}>
                <span className="hstack">
                    <i className="feather-users"></i>
                    <span>Grupo</span>
                </span>
            </Link>
        </div>
    </div>
  )
}
